import { Component, OnInit, AfterViewInit } from '@angular/core';
import { RedirectRequestHandler } from '@openid/appauth';
import { AuthorizationService } from '../services/authorization.service';
import { ActivatedRoute, Router } from '@angular/router';

@Component({
    selector: 'app-callback',
    templateUrl: './callback.component.html',
    styleUrls: ['./callback.component.scss']
})
export class CallbackComponent implements OnInit {

    constructor(private route: ActivatedRoute, public authorizationService: AuthorizationService, public router: Router) { }

    ngOnInit(): void {
    }

    ngAfterViewInit() {
        let codevalue;
        if (!window.location.hash || window.location.hash.length === 0) {
            const queryString = window.location.search.substring(1); // substring strips '?'
            const path = [window.location.pathname, queryString].join('#');
            window.location.assign(new URL(path, window.location.href).toString());
        } else if (new URLSearchParams(window.location.hash.substring(12)).has('code')) {
            this.route.queryParams.subscribe(
                params => {
                    codevalue = (params['code']);
                });
            this.authorizationService.completeAuthorizationRequest(codevalue).then((tokenResponse) => {
                console.log('recieved token response: ' + tokenResponse);                
                //if(tokenResponse != null) this.router.navigate(['AppCatalog']);
                let that=this;
                setTimeout(function(){ that.router.navigate(['/home/AppCatalog']); }, 1500);
            })

        } else {
            console.log('did not recognize callback in URL fragment or query');
            //this.router.navigate(['AppCatalog']);
        }
    }
}
